import {
  BooleanField,
  DateTimeField,
  NumberField,
  RelationshipFieldMany,
  StringField,
  LongTextField,
} from "../plugins/Cruxtify/field-types";
import {
  BooleanProperty,
  DateTimeProperty,
  NumberProperty,
  RelationshipPropertyMany,
  StringProperty,
} from "../plugins/Cruxtify/property-types";
import {
  UserPermission,
  UserPermissions,
  UserRole,
} from "../plugins/Cruxtify/UserPermission";
import { ApcCrudModel } from "./ApcCrudModel";

export class ProductLine extends ApcCrudModel {
  public static icon = "mdi-shape-outline";
  protected static _typeLabel = "Product Line";
  protected static asProperty = "productLine";
  public static api = {
    path: "product-lines",
  };

  protected static routeBase = "product-lines";

  protected static userPermissions = new UserPermissions(
    {
      [UserRole.SuperAdmin]: UserPermission.Edit,
      [UserRole.LoggedIn]: UserPermission.Read,
    },
    UserPermission.New
  );

  protected static propertyDefinitions = [
    {
      type: NumberProperty,
      opts: {
        name: "id",
        label: "ID",
        userPermissions: UserPermission.Hidden,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "created_at",
        label: "Created At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "updated_at",
        label: "Updated At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "deleted_at",
        label: "deleted At",
        userPermissions: UserPermission.Hidden,
        computed: true,
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "name",
        label: "Product Line Name",
        sortable: true,
        rules: ["required"],
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "code",
        label: "Product Line Code",
        sortable: true,
        rules: ["required"],
        userPermissions: UserPermission.New,
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "description",
        label: "Description",
      },
    },
    {
      type: RelationshipPropertyMany,
      opts: {
        name: "products",
        label: "Products",
        relatedModel: "Product",
        foreignProperty: "product_line",
      },
    },
  ];

  protected static fieldDefinitions = [
    {
      type: NumberField,
      opts: {
        property: "id",
        label: "ID",
      },
    },
    {
      type: StringField,
      opts: {
        property: "name",
        label: "Product Line Name",
        isPrimaryLabelField: 1,
      },
    },
    {
      type: StringField,
      opts: {
        property: "code",
        label: "Product Line Code",
      },
    },
    {
      type: StringField,
      opts: {
        property: "description",
        label: "Description",
        multiLine: true,
      },
    },
    {
      type: DateTimeField,
      opts: {
        property: "created_at",
        label: "Created At",
        readonly: true,
      },
    },
    {
      type: DateTimeField,
      opts: {
        property: "updated_at",
        label: "Updated At",
        readonly: true,
      },
    },
    {
      type: RelationshipFieldMany,
      opts: {
        property: "products",
        label: "Products",
        relatedModel: "Product",
        viewComponentName: "form-relationship-field-many-table",
        formComponentName: "form-relationship-field-many-table",
        collectionLayoutOpts: {
          enableSearch: true,
          enableDynamicFilters: true,
        },
      },
    },
  ];

  protected static collectionLayoutDefinitions = [
    {
      id: "table",
      columnFields: ["name", "code", "description", "created_at", "updated_at"],
      enableSearch: true,
      enableDynamicFilters: true,
      useModal: true,
      dynamicFilterOptions: {
        filterFields: [
          "name",
          "code",
          "description",
          "created_at",
          "updated_at",
        ],
      },
      defaultSort: [
        {
          field: "name",
          order: "asc",
        },
      ],
    },
  ];

  protected static modelLayoutDefinitions = [
    {
      type: "TabbedModelLayout",
      opts: {
        id: "tabs",
        tabs: [
          {
            id: "detailsTab",
            label: "Details",
            content: {
              type: "FieldSetGridLayout",
              opts: {
                id: "productLineDetails",
                fieldSets: [
                  {
                    id: "main",
                    fields: ["name", "code", "description"],
                  },
                  {
                    id: "meta",
                    fields: ["created_at", "updated_at", "id"],
                  },
                ],
              },
            },
          },
          {
            id: "productsTab",
            label: "Products",
            content: {
              type: "FieldSetGridLayout",
              opts: {
                fieldSets: [
                  {
                    id: "products",
                    fields: ["products"],
                  },
                ],
              },
            },
          },
        ],
      },
    },
  ];
}
